import CustomerDetail from './CustomerDetail';
import LoadAtom from './GlobalLoading';
import  Lang from './Lang';
import Plat from './Plat'
import MessageAtom from './message'


import { QueryParams } from './QueryParams';

export { CustomerDetail,Lang,Plat ,QueryParams,LoadAtom,MessageAtom}
